import { render, staticRenderFns } from "./NewInvite.vue?vue&type=template&id=0fef3840&"
import script from "./NewInvite.vue?vue&type=script&lang=js&"
export * from "./NewInvite.vue?vue&type=script&lang=js&"
import style0 from "./NewInvite.vue?vue&type=style&index=0&id=0fef3840&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports